export default function useDownloadToExcelViewEnquiry() {

    const getCookie = (n) => {
        let a = `; ${document.cookie}`.match(`;\\s*${n}=([^;]+)`);
        return a ? a[1] : "";
    };

    const downloadToExcel = (pageValues, dataFromEnquiry) => {
        let xlsx = require("json-as-xlsx");

        //get username
        let currentUser = "";

        if (document.cookie.length != 0) {
            currentUser = JSON.parse(getCookie("currentSatusLogUser"));
            //console.log("user name from cookie ", currentUser.user);
        } else {
            currentUser = "__"
        }


        //import the function you want to use
        const { format } = require("date-fns");
        //today's date
        const today = format(new Date(), "dd-MMM-yyyy");

        let uniqueKeyForEnquiry =
            currentUser.user + "-" + format(new Date(), "dd-MMM-yyyy-HH-mm-ss");

        console.log("before download to excel values", pageValues.table_row_values);

        let referenceForEnquiry = pageValues.reference;
        let remarksForEnquiry = pageValues.remarks;
        let postArrayForDownloadToExcel = pageValues.table_row_values
            .map((item, index) => {
                return {
                    sl_no: index + 1,
                    ord_Id: dataFromEnquiry
                        ? dataFromEnquiry.enquiry_number
                        : uniqueKeyForEnquiry,
                    ord_date: dataFromEnquiry ? dataFromEnquiry.date : today,
                    ord_ref: referenceForEnquiry,
                    ord_rem: remarksForEnquiry,
                    code: item.code,
                    description: item.description,
                    qty: item.req_ty, // qty: parseInt(item.qty, 10),  10: This is the base number used in mathematical systems. For our use, it should always be 10.
                    unit_price: item.unit_price,
                    item_amount: item.item_amount,
                    account: "",
                    c1: currentUser.user,
                    c2: "",
                    c3: "",
                    c4: dataFromEnquiry ? "MODIFY" : "NEW",
                    n1: 0,
                    n2: 0,
                    n3: 0,
                    d1: "",
                    d2: "",
                };
            });

            console.log("postArrayForDownloadToExcel ", postArrayForDownloadToExcel);
       

        let data = [
            {
                sheet: "Enquiry Details",
                columns: [
                    // eg "user" in column should be same as user in content else that column will be blank
                    { label: "Sl. No.", value: "sl_no" }, // Top level data // value : "user" should be same as content key double quotes required
                    { label: "Part Number", value: "code" }, // Run functions
                    { label: "Description", value: "description" },
                    { label: "Quantity", value: "qty" }, // Deep props
                ],
                content: postArrayForDownloadToExcel,
            },
        ];

        let settings = {
            fileName: uniqueKeyForEnquiry, // Name of the spreadsheet
            extraLength: 3, // A bigger number means that columns will be wider
            writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
        };

        xlsx(data, settings); // Will download the excel file



    };

    return [true, downloadToExcel];

}
